import path from "path";
import { mapFirmDocsMatterID } from "../../utilities/utilities";

export function processFilesForUpload(files, matterID, basepath) {
	let topLevelFolders = new Set();
	let topLevelFiles = [];
	let filesToUpload = [];
	let fileLocationInfo = [];
	let num = files.length;

	for (let f = 0; f < num; f++) {
		let file = files[f];

		let filePath = "";
		if (file.path) {
			filePath = path.dirname(file.path).slice(1);
		} else if (file.webkitRelativePath) {
			// does not have a leading slash
			filePath = path.dirname(file.webkitRelativePath);
		}
		// normalize filePath and trim whitespace off the end
		if (filePath) {
			// if filePath is an empty string it will upload to a directory named . which would break navigation and isn't intended location
			filePath = path.normalize(filePath).trim();
		}
		// if there is an empty string, it is a file at the top level
		let topLevel = filePath.split(path.sep)[0];
		// get basepath less the first item (i.e. docs/folder1/folder2 => folder1/folder2 )
		let currentLxwPath = basepath.split(path.sep).slice(1).join("/");

		if (topLevel) {
			topLevelFolders.add(topLevel);
		}
		if (!topLevel) {
			topLevelFiles.push({ name: file.name, path: filePath });
		}
		fileLocationInfo.push({
			originalLocation: filePath,
			currentLxwPath,
		});

		let stringMatterID = "";
		if (matterID === 0) {
			stringMatterID =
				mapFirmDocsMatterID(matterID, basepath) === -1
					? "public"
					: "private";
		}

		filesToUpload.push({
			lxwFilenameWithExtension: file.name,
			size: file.size,
			original: {
				LXW_MATTER_ID: stringMatterID ? stringMatterID : matterID,
				LXW_FOLDER: basepath ? currentLxwPath + filePath : filePath,
			},
		});
	}

	return {
		topLevelFolders: [...topLevelFolders],
		topLevelFiles,
		filesToUpload,
		fileLocationInfo,
	};
}

export function chunkArray(arr, len) {
	var chunks = [],
		i = 0,
		n = arr.length;

	while (i < n) {
		chunks.push(arr.slice(i, (i += len)));
	}

	return chunks;
}

/**
 * Merges mandatory profiling data with the files to upload array
 * @param {Array} filesToUpload - Array of file objects to upload
 * @param {Array} profilingData - Array of profiling data from the dialog
 * @returns {Array} - Updated filesToUpload array with profiling metadata (types, statuses, tags as arrays)
 */
export function mergeProfilingDataWithFiles(filesToUpload, profilingData) {
	if (!profilingData || profilingData.length === 0) {
		return filesToUpload;
	}

	// Create a map of filename to profiling data for quick lookup
	const profilingMap = {};
	profilingData.forEach((profileData) => {
		if (profileData.filename) {
			profilingMap[profileData.filename] = profileData;
		}
	});

	// Merge profiling data into filesToUpload
	return filesToUpload.map((file) => {
		const profileData = profilingMap[file.lxwFilenameWithExtension];

		if (!profileData) {
			return file;
		}

		// Extract values from profiling data
		const docType =
			profileData.documentType?.value || profileData.documentType;
		const docStatus =
			profileData.documentStatus?.value || profileData.documentStatus;
		const docTags = profileData.documentTags;

		// Format tags as array
		let docTagsArray = [];
		if (Array.isArray(docTags) && docTags.length > 0) {
			docTagsArray = docTags
				.map((tag) => tag.value || tag)
				.filter((tag) => tag);
		}

		// Add profiling data to the file's original object
		return {
			...file,
			original: {
				...file.original,
				...(docType && { LXW_DOC_TYPE: docType }),
				...(docStatus && { LXW_DOC_STATUS: docStatus }),
				...(docTagsArray.length > 0 && {
					LXW_DOC_TAGS_ARRAY: docTagsArray,
				}),
			},
		};
	});
}
